// extracted by mini-css-extract-plugin
module.exports = {"appBackground":"styles_appBackground__1gFOR","hideOnSmall":"styles_hideOnSmall__t0oEd"};